// axios
import axios from 'axios'

function setInterceptors(r) {
  r.interceptors.request.use(function (config) {
    if (config.method === 'get') {
      config.params = Object.assign({}, config.params, config.query, config.querys, config.data)
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  })
  
  r.interceptors.response.use(function (response) {
    const res = response.data
    if (response.status < 400 && res && res.status === 0) {
      return res.data
    }
    if (!res) {
      return {}
    }
    return Promise.reject(res.data)
    // return res.data;
  }, function (error) {
    return Promise.reject(error.response.data);
  });

}

const admin = axios.create({
  baseURL: window.__CONFIG__.api + "/admin/v1",
  headers: {
    Accept: 'application/json',
  },
  responseType: 'json',
  withCredentials: true,
})


const api = axios.create({
  baseURL: window.__CONFIG__.api + "/api/v1",
  headers: {
    Accept: 'application/json',
  },
  responseType: 'json',
  withCredentials: true,
})

setInterceptors(admin)
setInterceptors(api)

export default admin

export { api, admin }

